import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TRINHDO_API } from '@app/utils/apiUrl.js';
import { useMutation } from 'react-query';
import { Post } from '@app/utils/httpProvider';
import { messageToast, status200, status201 } from '@app/utils/define';

const schema = yup.object().shape({
    tenTrinhDo: yup.string().required('Tên trình độ không được để trống'),
    tenVanBangChungChi: yup.string().required('Tên văn bằng chứng chỉ không được để trống'),
    documentLink: yup.string()
});

const TrinhDoAdd = () => {
    const history = useHistory();

    const addFunc = useMutation((value) => Post(TRINHDO_API.ADD_ITEM, null, value, false));

    const handleCreate = async (values) => {
        addFunc.mutate(values, {
            onSuccess: (res) => {
                if (res && (res.status === status200 || res.status === status201)) {
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                } else {
                    toast.error(messageToast.messageToastCreateError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm trình độ</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        tenTrinhDo: '',
                        tenVanBangChungChi: '',
                        documentLink: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên trình độ
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập tên trình độ"
                                        type="text"
                                        name="tenTrinhDo"
                                        value={values.tenTrinhDo}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenTrinhDo}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenTrinhDo}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên văn bằng chứng chỉ
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập tên văn bằng chứng chỉ"
                                        type="text"
                                        name="tenVanBangChungChi"
                                        value={values.tenVanBangChungChi}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenVanBangChungChi}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenVanBangChungChi}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Đường dẫn tài liệu
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập đường dẫn tài liệu"
                                        type="text"
                                        name="documentLink"
                                        value={values.documentLink}
                                        onChange={handleChange}
                                        isInvalid={!!errors.documentLink}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.documentLink}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup>
                                        <Button type="submit" theme="primary" disabled={addFunc.isLoading}>
                                            Thêm
                                        </Button>
                                        <Button
                                            type="button"
                                            theme="secondary"
                                            onClick={() => history.goBack()}
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default TrinhDoAdd;
